import { render, staticRenderFns } from "./myApprovals.vue?vue&type=template&id=737d636a&scoped=true"
import script from "./myApprovals.vue?vue&type=script&lang=js"
export * from "./myApprovals.vue?vue&type=script&lang=js"
import style0 from "./myApprovals.vue?vue&type=style&index=0&id=737d636a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d636a",
  null
  
)

export default component.exports